import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import NavigationBreadcrumbs from '../../components/ui/NavigationBreadcrumbs';
import VerificationStatus from './components/VerificationStatus';
import PaymentDetails from './components/PaymentDetails';
import DocumentUpload from './components/DocumentUpload';
import ActivationTimeline from './components/ActivationTimeline';
import Button from '../../components/ui/Button';

const PaymentVerification = () => {
  const navigate = useNavigate();
  const [user] = useState({
    id: 1,
    name: "Carlos Andrés Martínez",
    email: "carlos.martinez@email.com",
    type: "user"
  });

  // Mock payment verification data
  const [verificationData] = useState({
    status: 'processing', // pending, processing, approved, rejected
    transactionRef: 'TRX-2025-12-001234',
    paymentMethod: 'Nequi',
    amount: 50000,
    fees: 2500,
    total: 52500,
    membershipTier: 'Emprendedor',
    submittedAt: new Date(Date.now() - 2 * 60 * 60 * 1000),
    estimatedCompletion: new Date(Date.now() + 22 * 60 * 60 * 1000)
  });

  const handleRetryPayment = () => {
    navigate('/user-registration');
  };

  const handleContactSupport = () => {
    window.open('https://wa.me/573001234567', '_blank');
  };

  const handleGoToDashboard = () => {
    navigate('/user-dashboard');
  };

  return (
    <div className="min-h-screen bg-background">
      <Header user={user} />
      <NavigationBreadcrumbs />
      
      <main className="main-content pb-12">
        <div className="max-w-4xl mx-auto">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-foreground mb-2">
              Verificación de Pago
            </h1>
            <p className="text-muted-foreground">
              Seguimiento del proceso de verificación y activación de tu membresía
            </p>
          </div>

          <div className="space-y-6">
            <VerificationStatus status={verificationData?.status} />

            <PaymentDetails 
              transactionRef={verificationData?.transactionRef}
              paymentMethod={verificationData?.paymentMethod}
              membershipTier={verificationData?.membershipTier}
              amount={verificationData?.amount}
              fees={verificationData?.fees}
              total={verificationData?.total}
              submittedAt={verificationData?.submittedAt}
              estimatedCompletion={verificationData?.estimatedCompletion}
            />

            <DocumentUpload 
              status={verificationData?.status}
              transactionRef={verificationData?.transactionRef}
            />

            <ActivationTimeline 
              status={verificationData?.status}
              submittedAt={verificationData?.submittedAt}
              estimatedCompletion={verificationData?.estimatedCompletion}
            />

            <div className="flex flex-col sm:flex-row gap-4">
              {verificationData?.status === 'rejected' && (
                <>
                  <Button 
                    onClick={handleRetryPayment}
                    className="flex-1"
                    iconName="RefreshCw"
                  >
                    Reintentar Pago
                  </Button>
                  <Button 
                    onClick={handleContactSupport}
                    variant="outline"
                    className="flex-1"
                    iconName="MessageCircle"
                  >
                    Contactar Soporte
                  </Button>
                </>
              )}

              {verificationData?.status === 'approved' && (
                <Button 
                  onClick={handleGoToDashboard}
                  className="flex-1"
                  iconName="ArrowRight"
                  iconPosition="right"
                >
                  Ir al Dashboard
                </Button>
              )}

              {(verificationData?.status === 'pending' || verificationData?.status === 'processing') && (
                <Button 
                  onClick={handleContactSupport}
                  variant="outline"
                  className="flex-1"
                  iconName="HelpCircle"
                >
                  ¿Necesitas Ayuda?
                </Button>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PaymentVerification;